import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import React from 'react'
import { createRoot } from 'react-dom/client'

import { FieldworkImportDetailGrids, FieldworkImportDetailGridsProps } from './FieldworkImportDetailGrids'

const theme = createTheme({
	palette: { mode: 'light', primary: { main: '#1976d2' } },
	components: {
		MuiDataGrid: { styleOverrides: { root: { border: 'none' } } },
	},
})

const parseMaybeJson = <T,>(raw: string | null | undefined): T | null => {
	if (!raw) {
		return null
	}
	try {
		return JSON.parse(raw) as T
	} catch {
		return null
	}
}

const initializedElements = new WeakSet<HTMLElement>()

const bootstrapOne = (el: HTMLElement): void => {
	if (initializedElements.has(el)) {
		return
	}

	const rows = parseMaybeJson<FieldworkImportDetailGridsProps['rows']>(el.getAttribute('data-rows')) ?? []
	const logs = parseMaybeJson<FieldworkImportDetailGridsProps['logs']>(el.getAttribute('data-logs')) ?? []
	const logDetailLink = el.getAttribute('data-log-detail-link') ?? ''

	initializedElements.add(el)

	const root = createRoot(el)
	root.render(
		<React.StrictMode>
			<ThemeProvider theme={theme}>
				<CssBaseline />
				<FieldworkImportDetailGrids rows={rows} logs={logs} logDetailLink={logDetailLink} />
			</ThemeProvider>
		</React.StrictMode>,
	)
}

export const bootstrapFieldworkImportDetail = (scope?: HTMLElement | Document): void => {
	const root = scope ?? document
	const elements: NodeListOf<HTMLElement> = root.querySelectorAll('.js-fieldwork-import-detail')
	elements.forEach((el) => bootstrapOne(el))
}

export { FieldworkImportDetailGrids }
